import type { ConsultaDaSala, EstadoDaSala } from "@bookdental/schemas";

export type Tom = "livre" | "atendimento" | "aguardando" | "atrasada" | "passou";

/** Cor de cada estado — semânticas fixas do projeto, sem gradiente nem sombra colorida. */
export const CLASSES_DO_TOM: Record<Tom, { caixa: string; selo: string }> = {
  livre: {
    caixa: "border-zinc-200 bg-white dark:border-border dark:bg-card",
    selo: "bg-zinc-100 text-zinc-600 dark:bg-muted dark:text-muted-foreground",
  },
  atendimento: {
    caixa: "border-brand-300 bg-brand-50 dark:border-primary/40 dark:bg-primary/10",
    selo: "bg-brand-600 text-white",
  },
  aguardando: {
    caixa: "border-amber-200 bg-amber-50 dark:border-amber-500/30 dark:bg-amber-500/10",
    selo: "bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-300",
  },
  atrasada: {
    caixa: "border-amber-300 bg-amber-50 dark:border-amber-500/40 dark:bg-amber-500/10",
    selo: "bg-amber-500 text-white",
  },
  passou: {
    caixa: "border-red-200 bg-red-50 dark:border-red-500/30 dark:bg-red-500/10",
    selo: "bg-red-600 text-white",
  },
};

const primeiroNome = (n?: string | null) => (n ? n.replace(/^(dr|dra)\.?\s+/i, "").split(/\s+/)[0] : null);

/** Quem é o paciente na tela: o nome quando pode, senão as iniciais. */
export const quem = (c: ConsultaDaSala) => c.pacienteNome ?? c.iniciais;

/** Rótulo, tom e a linha de detalhe de um estado, iguais na lista, na planta e na recepção. */
export function descrever(e: EstadoDaSala) {
  if (e.tipo === "em-atendimento") {
    return {
      tom: (e.passouDoHorario ? "passou" : "atendimento") as Tom,
      rotulo: e.passouDoHorario ? "Passou do horário" : "Em atendimento",
      consulta: e.consulta,
      dentista: primeiroNome(e.consulta.dentistName),
      horario: `${e.desde ? `desde ${e.desde}` : `previsto ${e.consulta.startTime}`} · até ${e.consulta.endTime}`,
      chegou: false,
    };
  }
  if (e.tipo === "aguardando-inicio") {
    return {
      tom: (e.atrasada ? "atrasada" : "aguardando") as Tom,
      rotulo: e.atrasada ? "Atrasada" : "Aguardando início",
      consulta: e.consulta,
      dentista: primeiroNome(e.consulta.dentistName),
      horario: `previsto ${e.consulta.startTime} às ${e.consulta.endTime}`,
      chegou: e.pacienteChegou,
    };
  }
  return {
    tom: "livre" as Tom,
    rotulo: "Livre",
    consulta: e.proxima,
    dentista: primeiroNome(e.proxima?.dentistName),
    horario: e.proxima ? `próxima às ${e.proxima.startTime}` : "sem mais consultas hoje",
    chegou: e.pacienteChegou,
  };
}
